import { createModel } from '@rematch/core';

import type { RootModel } from '.';
import { AuditLogExplorerTypes } from '../types/auditLogExplorer.types';

export interface AuditLogExplorerStoreProps {
    result: AuditLogExplorerTypes.SearchResult | null;
    detail: AuditLogExplorerTypes.DetailRow | null;
    loading: {
        search: boolean;
        detail: boolean;
    };
}

export const auditLogExplorerInitialState: AuditLogExplorerStoreProps = {
    result: null,
    detail: null,
    loading: {
        search: false,
        detail: false,
    },
};

export const auditLogExplorer = createModel<RootModel>()({
    state: auditLogExplorerInitialState,
    reducers: {
        toggleLoading: (
            store,
            prop: keyof AuditLogExplorerStoreProps['loading'],
            v: boolean,
        ) => {
            store.loading[prop] = v;
        },
        setResult: (store, result: AuditLogExplorerTypes.SearchResult) => {
            store.result = result;
        },
        setDetail: (store, detail: AuditLogExplorerTypes.DetailRow | null) => {
            store.detail = detail;
        },
    },
});
